import { nsSimCard } from '@/app/i18n/namespaces';
import SIM_CARDS_STATUS from '../enums/SimCardStatus';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'client_created_at'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'client_updated_at'
    },
    PROVIDER: {
        key: 'provider',
        LEGAL_NAME: {
            parentKeys: ['provider'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.legal_name',
            namespace: nsSimCard
        }
    },
    CLIENT: {
        key: 'client',
        UUID: {
            parentKeys: ['client'],
            key: 'uuid'
        },
        PROVIDER: {
            parentKeys: ['client'],
            key: 'provider',
            type: FIELD_TYPES.TEXT,
            entity: 'simCard_client_provider'
        },
        LEGAL_NAME: {
            parentKeys: ['client'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.legal_name',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.legal_name',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        }
    },
    SIM_CARD: {
        key: 'sim',
        UUID: {
            parentKeys: ['sim'],
            key: 'uuid'
        },
        CREATED_AT: {
            parentKeys: ['sim'],
            key: 'createdAt',
            type: FIELD_TYPES.DATE,
            entity: 'keys.created_at',
            namespace: nsSimCard,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        UPDATED_AT: {
            parentKeys: ['sim'],
            key: 'updatedAt',
            type: FIELD_TYPES.DATE,
            entity: 'keys.updated_at',
            namespace: nsSimCard,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        LABEL: {
            parentKeys: ['sim'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.label',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.label',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        },
        ICCID: {
            parentKeys: ['sim'],
            key: 'iccid',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.iccid',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.iccid',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        },
        ICCID_OPERATOR: {
            parentKeys: ['sim'],
            key: 'iccidOperator',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.operator',
            namespace: nsSimCard,
            isNested: true
        },
        STATUS: {
            parentKeys: ['sim'],
            key: 'status',
            type: FIELD_TYPES.BADGE,
            prefix: 'simCard_status_',
            entity: 'keys.status',
            namespace: nsSimCard,
            filter: FILTER_TYPES.SELECT,
            enum: SIM_CARDS_STATUS,
            enableSorting: true,
            isNested: true
        },
        DATA: {
            parentKeys: ['sim'],
            key: 'tariffData',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.data',
            namespace: nsSimCard,
            filter: FILTER_TYPES.PLAN,
            enableSorting: true,
            isNested: true
        },
        DATA_UNIT: {
            parentKeys: ['sim'],
            key: 'tariffDataUnit',
            entity: 'keys.unit',
            type: FIELD_TYPES.TEXT
        },
        TARIFF_NAME: {
            parentKeys: ['sim'],
            key: 'tariffName',
            entity: 'tariff_name',
            type: FIELD_TYPES.TEXT
        },
        IP_ADDRESS: {
            parentKeys: ['sim'],
            key: 'ipAddress',
            entity: 'simCard_ip',
            type: FIELD_TYPES.TEXT
        },
        MNO_ACCOUNT_ID: {
            parentKeys: ['sim'],
            key: 'mnoAccountId',
            entity: 'simCard_mno_account_id',
            type: FIELD_TYPES.TEXT
        },
        MNO_ACCOUNT_NAME: {
            parentKeys: ['sim'],
            key: 'mnoAccountName',
            entity: 'simCard_mno_account_name',
            type: FIELD_TYPES.TEXT
        },
        MNO_ID: {
            parentKeys: ['sim'],
            key: 'mnoId',
            entity: 'simCard_mno_id',
            type: FIELD_TYPES.TEXT
        },
        MNO_NAME: {
            parentKeys: ['sim'],
            key: 'mnoName',
            entity: 'keys.mno_name',
            namespace: nsSimCard,
            type: FIELD_TYPES.TEXT
        },
        APNS: {
            parentKeys: ['sim'],
            key: 'apns',
            entity: 'keys.apns',
            namespace: nsSimCard,
            type: FIELD_TYPES.TEXT
        },
        ACTIVATION_DATE: {
            parentKeys: ['sim'],
            key: 'activationDate',
            type: FIELD_TYPES.DATE_NO_TIME,
            entity: 'keys.activation_date',
            namespace: nsSimCard,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        ACTIVATION_REQUEST_DATE: {
            parentKeys: ['sim'],
            key: 'activationRequestDate',
            entity: 'keys.activation_request_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE_NO_TIME
        },
        CANCELLATION_DATE: {
            parentKeys: ['sim'],
            key: 'cancellationDate',
            type: FIELD_TYPES.DATE_NO_TIME,
            entity: 'keys.cancellation_date',
            namespace: nsSimCard,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        CANCELLATION_REQUEST_DATE: {
            parentKeys: ['sim'],
            key: 'cancellationRequestDate',
            entity: 'keys.cancellation_request_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE_NO_TIME
        },
        BILLING_DATE: {
            parentKeys: ['sim'],
            key: 'billingStartDate',
            entity: 'simCard_billing_start_date',
            type: FIELD_TYPES.DATE_NO_TIME
        },
        DISPATCH_DATE: {
            parentKeys: ['sim'],
            key: 'dispatchDate',
            entity: 'keys.dispatch_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE_NO_TIME
        },
        POS_TERMINAL: {
            parentKeys: ['sim'],
            key: 'posTerminal',
            entity: 'simCard_posTerminal',
            type: FIELD_TYPES.TEXT,
            MERCHANT: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'merchant',
                type: FIELD_TYPES.TEXT,
                entity: 'simCard_posTerminal_merchant'
            },
            UUID: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'uuid'
            },
            DIRECT_PROVIDER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'directProvider',
                type: FIELD_TYPES.TEXT,
                entity: 'simCard_posTerminal_directProvider'
            },
            SERIAL_NUMBER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'serialNumber',
                type: FIELD_TYPES.TEXT,
                entity: 'keys.serial_number',
                namespace: 'terminal',
                placeholder: 'filter.placeholder.serial_number',
                filter: FILTER_TYPES.INPUT,
                enableSorting: true,
                isNested: true
            },
            MANUFACTURER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'manufacturer',
                type: FIELD_TYPES.TEXT,
                entity: 'keys.manufacturer',
                namespace: 'terminal',
                placeholder: 'filter.placeholder.manufacturer',
                filter: FILTER_TYPES.INPUT,
                enableSorting: true,
                isNested: true
            },
            STATUS_TPE: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'status',
                entity: 'simCard_posTerminal_status',
                type: 'select'
            },
            STATUS_SUBSCRIPTION: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'subscriptionStatus',
                entity: 'simCard_posTerminal_subscription_status',
                type: 'select'
            },
            LAST_GPRS_CALL: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'lastGprsCall',
                type: FIELD_TYPES.DATE,
                entity: 'keys.last_gprs_call',
                namespace: 'terminal',
                filter: FILTER_TYPES.DATE,
                enableSorting: true,
                isNested: true
            },
            LAST_IP_CALL: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'lastIpCall',
                type: FIELD_TYPES.DATE,
                entity: 'simCard_posTerminal_IP_last_connection'
            }
        },
        DATA_USAGE: {
            parentKeys: ['sim'],
            key: 'dataUsage',
            type: 'chart',
            entity: 'keys.data_usage',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.data_usage',
            tooltip: 'tooltip.data_usage',
            filter: FILTER_TYPES.NUMBER,
            enableSorting: true,
            isNested: true
        },
        LAST_COMM_DATE: {
            parentKeys: ['sim'],
            key: 'lastCommunicationDate',
            entity: 'keys.last_comm_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE
        },
        FIRST_COMM_DATE: {
            parentKeys: ['sim'],
            key: 'firstCommunicationDate',
            entity: 'keys.first_comm_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE
        },
        END_OF_ENGAGEMENT_DATE: {
            parentKeys: ['sim'],
            key: 'endOfEngagementDate',
            entity: 'keys.end_engagement_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE_NO_TIME
        },
        SUSPENSION_DATE: {
            parentKeys: ['sim'],
            key: 'suspensionDate',
            entity: 'keys.suspension_date',
            namespace: nsSimCard,
            type: FIELD_TYPES.DATE_NO_TIME
        },
        NEXT_OFFER: {
            parentKeys: ['sim'],
            key: 'nextOffer',
            entity: 'simCard_next_offer',
            type: FIELD_TYPES.TEXT
        },
        NEXT_ICCID: {
            parentKeys: ['sim'],
            key: 'nextIccid',
            entity: 'simCard_next_iccid',
            type: FIELD_TYPES.TEXT
        },
        OFFER_CAN_BE_UPDATED: {
            parentKeys: ['sim'],
            key: 'offerCanBeUpdated',
            entity: 'simCard_offer_can_be_updated',
            type: FIELD_TYPES.TEXT
        },
        PROVIDER: {
            parentKeys: ['sim'],
            key: 'provider',
            type: FIELD_TYPES.TEXT
        },
        SIM_PROVIDER: {
            parentKeys: ['sim'],
            key: 'simProvider',
            type: FIELD_TYPES.TEXT
        }
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    SIM_OFFERS: {
        key: 'simOffers',
        UUID: {
            parentKeys: ['simOffers'],
            key: 'uuid'
        },
        DATA: {
            parentKeys: ['simOffers'],
            key: 'data'
        },
        DATA_UNIT: {
            parentKeys: ['simOffers'],
            key: 'dataUnit'
        },
        DISPLAY_NAME: {
            parentKeys: ['simOffers'],
            key: 'displayName',
            altKey: 'name'
        },
        PROVIDER_OFFER_NAME: {
            parentKeys: ['simOffers'],
            key: 'providerOfferName'
        },
        RANK: {
            parentKeys: ['simOffers'],
            key: 'rank'
        },
        SHORT_DISPLAY_NAME: {
            parentKeys: ['simOffers'],
            key: 'shortDisplayName'
        },
        SIM_PROVIDER_NAME: {
            parentKeys: ['simOffers'],
            key: 'simProviderName'
        }
    },
    SIM_PROVIDERS: {
        key: 'simProviders',
        PROVIDER_NAME: {
            parentKeys: ['simProviders'],
            key: 'providerName'
        },
        QUANTITIES: {
            parentKeys: ['simProviders'],
            key: 'quantities'
        }
    }
};